import router from '@/router'
import cmd from '@/common/Command'

const ImageModule = {
  namespaced: true,
  state: {
    rows: [],
    images: ""
  },
  mutations: {
    setRows (state, value) {
      state.rows = value 
    },
    setImages (state, value) {
      state.images = value 
    }
  },
  actions: {
    //前ページ
    prevAction ({ commit, state, rootState }) {
      router.go(-1)
    },
    //
    search ({ commit, state, rootState }) {
      
      function callback(rows){
        var list = []
        $.each(rows, function(idx, row){
          if (row != "") {            
            list.push({"id": idx, "value" : row[0], "images": row[1]}) 
          }
        })
        commit('setRows', list)
      }
      cmd.getData("image", callback)
      
    
      var list = [
        {"value" : "図版1", "id": "1", "images": "static/images/inner1.jpg,static/images/inner2.jpg,static/images/inner3.jpg"},
        {"value" : "図版2", "id": "2", "images": "static/images/inner1.jpg,static/images/inner2.jpg,static/images/inner3.jpg"},
        {"value" : "図版3", "id": "3", "images": "static/images/inner1.jpg,static/images/inner2.jpg,static/images/inner3.jpg"},
      ]

      commit('setRows', list)
          
    },
    //次ページ
    showDetail ({ commit, state, rootState }, id) {

      var images = []
      $.each(state.rows, function(idx, row){
          if (row.id == id) {
            images = row.images.split(",")
            return false
          }
      })
      commit('setImages', images)
      router.push('imageDetail')
    },

  },
  getters: {    
    getRows (state, getters, rootState) {
      return state.rows
    },
    images (state, getters, rootState) {
      return state.images
    }
    
  }
}

export default ImageModule



// WEBPACK FOOTER //
// ./src/store/modules/ImageModule.js